import CurrencyNumber from "app/components/CurrencyNumber/CurrencyNumber";
import OddsFormatter from "app/components/OddsFormatter/OddsFormatter";
import { TimeDateHelper } from "app/helpers/timeDateHelper";
import { ExchangeBetType } from "app/types/reportType";
import { OddsType } from "app/utils/const";
import React from "react";
import { FormattedMessage } from "react-intl";
import StatementExchangeBetsStatus from "./StatementExchangeBetsStatus";

const StatementExchangeBetsContent: React.FC<{
  statementList: ExchangeBetType[];
  finalScores: string;
}> = ({ statementList, finalScores }) => {
  return (
    <>
      {statementList.map((bet, index) => {
        const cancelled =
          bet.status.toLowerCase() === "cancelled" ||
          bet.status.toLowerCase() === "void"
            ? "statement-exchange-cell--red-text"
            : "";
        return (
          <React.Fragment key={index}>
            <div
              className={`statement-exchange-cell statement-exchange-cell--multiline ${cancelled}`}
            >
              <span>
                {TimeDateHelper.getFormattedDateTime(
                  bet.datePlaced,
                  "DD/MM/YYYY"
                )}
              </span>
              <span>
                {TimeDateHelper.getFormattedDateTime(
                  bet.datePlaced,
                  "HH:mm:ss"
                )}
              </span>
              <span>
                <FormattedMessage id="reports-id" />: {bet.betId}
              </span>
            </div>
            <div
              className={`statement-exchange-cell statement-exchange-cell--multiline ${cancelled}`}
            >
              <span>
                {TimeDateHelper.getFormattedDateTime(
                  bet.dateSettled,
                  "DD/MM/YYYY"
                )}
              </span>
              <span>
                {TimeDateHelper.getFormattedDateTime(
                  bet.dateSettled,
                  "HH:mm:ss"
                )}
              </span>
            </div>
            <div className={`statement-exchange-cell ${cancelled}`}>
              <span>{bet.selectionName}</span>
            </div>
            <div
              className={`statement-exchange-cell  statement-exchange-cell--center ${cancelled}`}
            >
              {bet.odds && (
                <OddsFormatter odds={bet.odds} oddsType={OddsType.DECIMAL} /> //Exchange bets are always decimal
              )}
            </div>
            <div
              className={`statement-exchange-cell statement-exchange-cell--number  ${cancelled}`}
            >
              <span>
                <CurrencyNumber value={bet.stake} />
              </span>
            </div>
            <div
              className={`statement-exchange-cell  statement-exchange-cell--center ${cancelled}`}
            >
              <span>{bet.side}</span>
            </div>

            <StatementExchangeBetsStatus
              betStatus={bet.status}
              translatedbetStatus={bet.translatedStatus}
              cancellationNote={bet.cancellationNote || ""}
              betId={index}
              finalScores={finalScores}
            />

            <div
              className={`statement-exchange-cell statement-exchange-cell--number  ${cancelled}`}
            >
              <span>
                <CurrencyNumber value={bet.payout} />
              </span>
            </div>
          </React.Fragment>
        );
      })}
    </>
  );
};

export default StatementExchangeBetsContent;
